// One number for the Settings entry in the main app sidebar: the sum of every badge
// the settings sidebar shows on its own items. The main sidebar has no room to
// explain *what* needs attention, so it reports only *how much*, and clicking
// through to Settings shows which item carries it.
//
// Adding a badge to a settings item means adding its hook here too -- otherwise the
// two navs disagree about how much is outstanding, which is worse than no badge.
import { useDetectedSourcesCount } from "./useDetectedSourcesCount";
import { useLastRunFailureCount } from "./useLastRunFailureCount";

// A badge that reads "NaN" in the chrome of every page is a worse failure than one
// that under-reports, so anything non-numeric counts as nothing.
const asCount = (value) => (typeof value === "number" && Number.isFinite(value) ? value : 0);

export function useSettingsBadgeCount() {
  const detected = useDetectedSourcesCount();
  const failures = useLastRunFailureCount();
  return asCount(detected) + asCount(failures);
}
